
window.longWordsThreshold = 30;

function initLongWords(trial){
    return isLongWords(trial);

  function isLongWords(trialRow){
    if(!isTrialOfType(trialRow, "word")){
      return false;
    }

    for(var i = 1; i <= listNoStim[trialRow]; i++){
      var currentStim = getStimForTrialRow(trialRow, i - 1);
      // strip html tags
      currentStim = currentStim.replace(/(<([^>]+)>)/ig,"");
      if(currentStim.length > window.longWordsThreshold){
        return true;
      }
    }
    return false;
  }
}

function isLongWordTrial(trial){
  return window.listTrialLongWords[trial] === true;
}

function positionLongWords(fromIndex, n){
    var displayScreenElem = document.getElementById('displayScreen');
    var minTop = 0;

    const longWordMargin = 20 * adjuster;
    const longWordPadding = 20 * adjuster;
    const longWordWidth = displayScreenElem.clientWidth;

    var heights = [];
    var totalHeight = 0;
    for(var i = fromIndex + 1; i <= fromIndex + n; i++){
        applyLongWordStyle(stimContainers[i], n - fromIndex, longWordPadding, longWordWidth);
        totalHeight +=  stimContainers[i].clientHeight;
        heights[i] =  stimContainers[i].clientHeight;
    }

    totalHeight += longWordMargin * n;

    var nextTop = displayScreenElem.clientHeight / 2 - totalHeight/2;

    if(nextTop < 0){
      nextTop = 0;
    }
    minTop = nextTop;

    for(var i = fromIndex + 1; i <= fromIndex + n; i++){
      stimContainers[i].style.top = nextTop + "px";
      nextTop += longWordMargin + heights[i];
    }

    makeLongWordsVisible(fromIndex, n);

    return minTop;
}

function cleanLongWords(){
  for(var i = 1; i <= window.stimFieldsMax; i++){
    stimContainers[i].style.textAlign = "center";
    stimContainers[i].style.padding = "";
    stimContainers[i].style.backgroundColor = "";
    stimContainers[i].style.lineHeight = "";
    stimContainers[i].style.borderWidth = "";
    stimContainers[i].style.alignItems = "";
    stimContainers[i].style.borderRadius = "";
    stimContainers[i].style.visibility = "";
    stimContainers[i].style.height = "";
    stimContainers[i].style.margin = "";
  }
}

function applyLongWordStyle(stim, stimCount, longWordPadding, longWordWidth){
  stim.classList.remove("word");
  stim.classList.add("longword");
  stim.style.width = longWordWidth + "px";
  stim.style.left = "" ;
  stim.style.textAlign = "center";

  if(stimCount > 1 && window.columnForTrial('responseType', window.trialRow) == 'clicks'){
    stim.style.backgroundColor = "#f0f0f0";
    stim.style.padding = longWordPadding + "px";
    stim.style.lineHeight = 1.5;
    stim.style.borderWidth = "1px";
  }

  stim.style.alignItems = "center";
  stim.style.borderRadius = "5px";
  stim.style.visibility = "hidden";
  stim.style.display = "";
  stim.style.height = "";
  stim.style.margin = "0 auto";
  stim.style.fontSize = "2em";
}

function makeLongWordsVisible(fromIndex, n){
  for(var i = fromIndex + 1; i <= n + fromIndex; i++){
    var currentStimuli = stimContainers[i];
    currentStimuli.style.visibility = "";
    currentStimuli.style.display = "";
  }
}